/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import * as Yup from "yup";
 export const addonsSchema = Yup.object().shape({
  name: Yup.string()
      .max(50, "Maximum 50 letters")
      .required("Name is required"),
typeId: Yup.string().required("Type is required"),
  amount: Yup.number()
    .required("Price is required")
    .typeError("Price must be a number")
    .test(
      "is-floating-number",
      "Price must be a floating-point number",
      (value) => {
        const stringValue = String(value);
        return (
          !isNaN(parseFloat(stringValue)) && /^\d*\.?\d*$/.test(stringValue)
        );
      }
    ),
});